var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',[_vm._v("路由信息："+_vm._s(_vm.$route.fullPath))]),_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/img/logo.png")}}),_c('HelloWorld',{attrs:{"msg":"德州家医"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }